import { render, staticRenderFns } from "./Admiral.vue?vue&type=template&id=04c21696"
import script from "./Admiral.vue?vue&type=script&lang=js"
export * from "./Admiral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports